import React from 'react';

import { NodeProps } from './shared';

import { OrderedList } from '../styles';

export function OrderedListNode({ children }: NodeProps) {
  return <OrderedList>{children}</OrderedList>;
}
